import type * as React from "react";

type HeaderProps = {
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  centerComponent?: React.ReactNode;
  className?: string;
};

export default function Header({
  leftComponent,
  rightComponent,
  centerComponent,
  className,
}: HeaderProps) {
  return (
    <div className={`header ${className}`} data-main-header>
      {leftComponent}
      {centerComponent}
      {rightComponent}
    </div>
  );
}
